import BaseApi from '@/api/controller/base';

const CLIENT_API_URL = 'client/';

class ClientApi extends BaseApi {
  constructor() {
    super(CLIENT_API_URL);
  }

  get(id) {
    return this.api.get(`${id}`);
  }

  getEarlyBird(id) {
    return this.api.get(`${id}/earlyBird`);
  }

  getPaystubs(id) {
    return this.api.get(`${id}/paystubs`);
  }

  getReferrals(id) {
    return this.api.get(`${id}/referrals`);
  }

  submitEarlyBirdQualification(clientId, qualification) {
    return this.api.post(`${clientId}/submitEarlyBirdQualification`, qualification);
  }

  submitEarlyBirdEnrollment(clientId, enrollment) {
    return this.api.post(`${clientId}/submitEarlyBirdEnrollment`, enrollment);
  }

  submitEarlyBirdEnrollmentWithApproval(clientId, enrollment, accessToken) {
    return this.api.post(`${clientId}/submitEarlyBirdEnrollment`, enrollment, {
      headers: {
        Authorization: `Bearer ${accessToken.token}`,
      },
    });
  }

  getGridData(params) {
    return this.api.post('gridData', params);
  }

  findBySSN(ssn) {
    return this.api.get('findBySSN', {
      params: {
        ssn,
      },
    });
  }

  saveClient(clientData) {
    return this.api.post('', clientData);
  }

  import(file) {
    const formData = new FormData();
    formData.append('clientData', file);
    // Setting type to null let's attach set the type for us
    return this.api.post('import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

const apiInstance = new ClientApi();
export { ClientApi, apiInstance };
export default apiInstance;
